var _defs, _rect, _rect2, _rect3, _g, _rect4, _rect5, _line, _rect6, _path, _text, _rect7, _rect8, _rect9, _g2, _text2, _rect10, _rect11, _rect12, _g3, _rect13, _rect14, _g4, _path2, _path3, _path4, _circle, _rect15, _g5, _text3, _rect16, _rect17, _g6, _g7, _g8, _text4, _g9, _rect18, _rect19, _rect20, _rect21, _rect22, _g10, _rect23, _text5, _rect24, _text6, _rect25, _circle2, _text7, _rect26, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAtlasCover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1600,
    height: 1000,
    viewBox: "0 0 1600 1000",
    fontFamily: "Helvetica, Arial, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 48,
    height: 48,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0V48",
    fill: "none",
    stroke: "#94A3B8",
    strokeOpacity: 0.08
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow",
    cx: 0.8,
    cy: 0.1,
    r: 0.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7C3AED",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "area",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7C3AED",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "220%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 30,
    stdDeviation: 30,
    floodColor: "#000",
    floodOpacity: 0.45
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1000,
    fill: "#0F172A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1000,
    fill: "url(#grid)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1000,
    fill: "url(#glow)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 150,
    width: 1130,
    height: 720,
    rx: 18,
    fill: "#F8FAFC"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 150,
    width: 210,
    height: 720,
    rx: 18,
    fill: "#FFFFFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 150,
    width: 20,
    height: 720,
    fill: "#FFFFFF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 150,
    x2: 460,
    y2: 870,
    stroke: "#E2E8F0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 178,
    width: 34,
    height: 34,
    rx: 9,
    fill: "#7C3AED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M293 186 302 195 293 204 284 195Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 322,
    y: 201,
    fontSize: 18,
    fontWeight: 700,
    fill: "#0F172A"
  }, "ATLAS")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 244,
    width: 170,
    height: 38,
    rx: 9,
    fill: "#F5F3FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 258,
    width: 14,
    height: 12,
    rx: 3,
    fill: "#7C3AED"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 259,
    width: 78,
    height: 10,
    rx: 5,
    fill: "#6D28D9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#CBD5E1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 304,
    width: 14,
    height: 12,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 305,
    width: 64,
    height: 10,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 346,
    width: 14,
    height: 12,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 347,
    width: 84,
    height: 10,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 388,
    width: 14,
    height: 12,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 389,
    width: 56,
    height: 10,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 430,
    width: 14,
    height: 12,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 431,
    width: 72,
    height: 10,
    rx: 5
  }))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 492,
    y: 206,
    fontSize: 26,
    fontWeight: 700,
    fill: "#0F172A"
  }, "Revenue overview")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 492,
    y: 222,
    width: 230,
    height: 10,
    rx: 5,
    fill: "#CBD5E1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 1162,
    y: 184,
    width: 190,
    height: 40,
    rx: 10,
    fill: "#F1F5F9",
    stroke: "#E2E8F0"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 1230,
    y: 188,
    width: 60,
    height: 32,
    rx: 7,
    fill: "#FFFFFF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 492,
    y: 260,
    width: 200,
    height: 110,
    rx: 12,
    fill: "#fff",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 282,
    width: 110,
    height: 9,
    rx: 4.5,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("text", {
    x: 512,
    y: 332,
    fontSize: 30,
    fontWeight: 700,
    fill: "#0F172A"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontSize: 16,
    fill: "#64748B"
  }, "DKK "), "248.6k"), /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 346,
    width: 58,
    height: 14,
    rx: 7,
    fill: "#CCFBF1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 712,
    y: 260,
    width: 200,
    height: 110,
    rx: 12,
    fill: "#fff",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 732,
    y: 282,
    width: 90,
    height: 9,
    rx: 4.5,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("text", {
    x: 732,
    y: 332,
    fontSize: 30,
    fontWeight: 700,
    fill: "#0F172A"
  }, "1,284"), /*#__PURE__*/React.createElement("rect", {
    x: 732,
    y: 346,
    width: 48,
    height: 14,
    rx: 7,
    fill: "#CCFBF1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 932,
    y: 260,
    width: 200,
    height: 110,
    rx: 12,
    fill: "#fff",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 952,
    y: 282,
    width: 120,
    height: 9,
    rx: 4.5,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("text", {
    x: 952,
    y: 332,
    fontSize: 30,
    fontWeight: 700,
    fill: "#0F172A"
  }, "112%"), /*#__PURE__*/React.createElement("rect", {
    x: 952,
    y: 346,
    width: 58,
    height: 14,
    rx: 7,
    fill: "#CCFBF1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 260,
    width: 200,
    height: 110,
    rx: 12,
    fill: "#fff",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1172,
    y: 282,
    width: 70,
    height: 9,
    rx: 4.5,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1172,
    y: 332,
    fontSize: 30,
    fontWeight: 700,
    fill: "#0F172A"
  }, "1.9%"), /*#__PURE__*/React.createElement("rect", {
    x: 1172,
    y: 346,
    width: 58,
    height: 14,
    rx: 7,
    fill: "#CCFBF1"
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 492,
    y: 390,
    width: 560,
    height: 300,
    rx: 12,
    fill: "#fff",
    stroke: "#E2E8F0"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 412,
    width: 190,
    height: 11,
    rx: 5.5,
    fill: "#334155"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#E2E8F0"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 512,
    y1: 470,
    x2: 1032,
    y2: 470
  }), /*#__PURE__*/React.createElement("line", {
    x1: 512,
    y1: 530,
    x2: 1032,
    y2: 530
  }), /*#__PURE__*/React.createElement("line", {
    x1: 512,
    y1: 590,
    x2: 1032,
    y2: 590
  }), /*#__PURE__*/React.createElement("line", {
    x1: 512,
    y1: 650,
    x2: 1032,
    y2: 650
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M520 600 L566 592 L612 585 L658 576 L704 571 L750 562 L796 552 L842 543 L888 532 L934 522 L980 510 L1024 498 L1024 650 L520 650Z",
    fill: "url(#area)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M520 600 L566 592 L612 585 L658 576 L704 571 L750 562 L796 552 L842 543 L888 532 L934 522 L980 510 L1024 498",
    fill: "none",
    stroke: "#7C3AED",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M520 636 L566 630 L612 625 L658 621 L704 614 L750 610 L796 603 L842 599 L888 593 L934 588 L980 582 L1024 574",
    fill: "none",
    stroke: "#94A3B8",
    strokeWidth: 2.5,
    strokeDasharray: "7 6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 498,
    r: 6,
    fill: "#7C3AED",
    stroke: "#fff",
    strokeWidth: 3
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 1072,
    y: 390,
    width: 280,
    height: 300,
    rx: 12,
    fill: "#fff",
    stroke: "#E2E8F0"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 1212 540)",
    fill: "none",
    strokeWidth: 26
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1212,
    cy: 540,
    r: 78,
    stroke: "#7C3AED",
    strokeDasharray: "253 490"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1212,
    cy: 540,
    r: 78,
    stroke: "#3B82F6",
    strokeDasharray: "148 490",
    strokeDashoffset: -256
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1212,
    cy: 540,
    r: 78,
    stroke: "#14B8A6",
    strokeDasharray: "80 490",
    strokeDashoffset: -407
  }))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 1212,
    y: 550,
    fontSize: 22,
    fontWeight: 700,
    fill: "#0F172A",
    textAnchor: "middle"
  }, "DKK 249k")), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 492,
    y: 710,
    width: 860,
    height: 140,
    rx: 12,
    fill: "#fff",
    stroke: "#E2E8F0"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 493,
    y: 711,
    width: 858,
    height: 38,
    rx: 11,
    fill: "#F8FAFC"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#94A3B8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 552,
    y: 726,
    width: 70,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 726,
    width: 50,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 726,
    width: 60,
    height: 8,
    rx: 4
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 764,
    width: 16,
    height: 16,
    rx: 4,
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552,
    y: 767,
    width: 150,
    height: 10,
    rx: 5,
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 767,
    width: 80,
    height: 10,
    rx: 5,
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 762,
    width: 72,
    height: 20,
    rx: 10,
    fill: "#CCFBF1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 493,
    y1: 796,
    x2: 1351,
    y2: 796,
    stroke: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 810,
    width: 16,
    height: 16,
    rx: 4,
    fill: "none",
    stroke: "#94A3B8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552,
    y: 813,
    width: 130,
    height: 10,
    rx: 5,
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 813,
    width: 64,
    height: 10,
    rx: 5,
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 808,
    width: 80,
    height: 20,
    rx: 10,
    fill: "#FEF3C7"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 560,
    width: 270,
    height: 200,
    rx: 16,
    fill: "#FFFFFF"
  }))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 144,
    y: 598,
    fontSize: 16,
    fontWeight: 700,
    fill: "#0F172A"
  }, "Violet")), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 616,
    width: 22,
    height: 64,
    fill: "#F5F3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 616,
    width: 22,
    height: 64,
    fill: "#EDE9FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 616,
    width: 22,
    height: 64,
    fill: "#DDD6FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 616,
    width: 22,
    height: 64,
    fill: "#C4B5FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 616,
    width: 22,
    height: 64,
    fill: "#A78BFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 616,
    width: 22,
    height: 64,
    fill: "#8B5CF6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 616,
    width: 22,
    height: 64,
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298,
    y: 616,
    width: 22,
    height: 64,
    fill: "#6D28D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 616,
    width: 22,
    height: 64,
    fill: "#5B21B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342,
    y: 616,
    width: 24,
    height: 64,
    fill: "#4C1D95"
  }))), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 700,
    width: 40,
    height: 28,
    rx: 7,
    fill: "#7C3AED"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 700,
    width: 40,
    height: 28,
    rx: 7,
    fill: "#3B82F6"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 700,
    width: 40,
    height: 28,
    rx: 7,
    fill: "#14B8A6"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 700,
    width: 40,
    height: 28,
    rx: 7,
    fill: "#F43F5E"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 700,
    width: 38,
    height: 28,
    rx: 7,
    fill: "#0F172A"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1250,
    y: 80,
    width: 280,
    height: 150,
    rx: 16,
    fill: "#FFFFFF"
  }))), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 1274,
    y: 104,
    width: 120,
    height: 40,
    rx: 9,
    fill: "#7C3AED"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 1334,
    y: 130,
    fontSize: 15,
    fontWeight: 700,
    fill: "#fff",
    textAnchor: "middle"
  }, "+ Create")), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 1404,
    y: 104,
    width: 102,
    height: 40,
    rx: 9,
    fill: "#fff",
    stroke: "#CBD5E1"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 1455,
    y: 130,
    fontSize: 15,
    fontWeight: 600,
    fill: "#0F172A",
    textAnchor: "middle"
  }, "Export")), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 1274,
    y: 164,
    width: 76,
    height: 24,
    rx: 12,
    fill: "#F0FDFA",
    stroke: "#99F6E4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1290,
    cy: 176,
    r: 4,
    fill: "#0F766E"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 1300,
    y: 181,
    fontSize: 13,
    fontWeight: 700,
    fill: "#0F766E"
  }, "Active")), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 1466,
    y: 164,
    width: 40,
    height: 24,
    rx: 12,
    fill: "#7C3AED"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1494,
    cy: 176,
    r: 9,
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlasCover);
export default __webpack_public_path__ + "static/media/atlas-cover.a6b15b49c2c3faab0d5456de39eaae44.svg";
export { ForwardRef as ReactComponent };